import { LOAD_SURVEY_RESULTS } from '../../actions/surveys'
import * as h2Api from '../../h2Api'

const initialState = {
  questions: [],
  multiChoiceSummary: [],
  ratingSummary: [],
  responses: []
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SURVEY_RESULTS:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          ...action.restCall.result
        }
      }

      return state

    default:
      return state
  }
}

export default reducers
